export default __webpack_public_path__ + "5056d92e6d1fe47f488b50bfa793d8ca.png";